import { ReactComponent as FilledPinned } from "assets/FilledPinned.svg";
import { ReactComponent as PinOff } from "assets/PinOff.svg";
import { filterPage } from "components/common/Filters/FiltersHelper";
import Tabs from "components/common/Tabs";
import { useURL } from "hooks/URLProvider";
import { isUndefined } from "lodash";
import { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import IndividualProperty from "../../IndividualProperty";
import { setCreatedDate } from "../HotelUserDashboard.slice";
import HotelUserDashboardWrapper from "../HotelUserDashboardWrapper";
import InnCodeWrapper from "../InncodeWrapper";
import "./Home.scss";
import "./PropertyOverview.scss";
import {
  fetchTabPinUnpin,
  putTabPinUnpin,
  setPinIndex,
  setPinnedTab,
  setUseEffectState
} from "./PropertyOverview.slice";

export const HomePageTabs = [
  {
    label: "My Dashboard",
    content: HotelUserDashboardWrapper,
    pinValue: "my_dashboard"
  },
  {
    label: "Property Overview",
    content: IndividualProperty,
    pinValue: "dashboard_property_overview",
    filtersToClear: [
      filterPage.individualPropertyPlansDisplay,
      filterPage.individualPropertyBrandDeadlineDisplay,
      filterPage.individualPropertyInitiativesDisplay,
      filterPage.individualPropertyMembersDisplay
    ]
  }
];

const Home = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const isuseEffectRun = useAppSelector((state) => state.PropertyOverviewSlice.isuseEffectRun);
  const pinIndex = useAppSelector((state) => state.PropertyOverviewSlice.pinIndex);
  const [searchParams, setSearchParams] = useSearchParams();
  const isLeadership = useAppSelector((state) => state.app.loggedInUserDetails.isLeadership);

  const lastURL = useURL();
  const externalHltId = searchParams.get("member");

  const pinHandler = (e: any) => {
    e.stopPropagation();
  };

  const queryParam = searchParams.get("parentTab");

  const selectTab = (index: any) => {
    const selectedTab = index === 0 ? "My Dashboard" : "Property Overview";
    setSearchParams({ parentTab: selectedTab.toString() });
  };

  useEffect(() => {
    if (isuseEffectRun || location?.state?.hasNoAccess || location?.state?.viewChange) {
      (async () => {
        if (isLeadership) {
          const tabInfo: any = await dispatch(fetchTabPinUnpin());
          const res = tabInfo?.payload?.pinned[0]?.view;
          const selectedTab = isUndefined(res)
            ? "My Dashboard"
            : res === "my_dashboard"
            ? "My Dashboard"
            : "Property Overview";
          const pin = isUndefined(res) ? 0 : res === "dashboard_property_overview" ? 1 : 0;
          dispatch(setPinIndex(pin));
          let newSelectedTab = "";
          if (lastURL === "/" && queryParam) {
            newSelectedTab = queryParam;
          } else {
            newSelectedTab = selectedTab;
          }
          navigate(`${location.pathname}?parentTab=${newSelectedTab.toString()}`, {
            state: location.state,
            replace: true
          });
          dispatch(setPinnedTab(res));
        }
      })();
    }
    dispatch(setUseEffectState(false));
  }, [isLeadership]);

  const handlePinUnpin = async (data: string) => {
    const payload = {
      page: "dashboard",
      view: data,
      isFlagged: "Y"
    };
    const pin: any = await dispatch(putTabPinUnpin(payload));
    const tab = pin.payload?.pinned[0]?.view;
    const res = tab === "dashboard_property_overview" ? 1 : 0;
    dispatch(setPinIndex(res));
  };

  const isOverviewSelected = queryParam === "Property Overview";

  return (
    <>
      <InnCodeWrapper />
      {externalHltId || !isLeadership ? (
        <HotelUserDashboardWrapper />
      ) : (
        <>
          {queryParam && (
            <div className={"component-wrapper"}>
              <Tabs
                className={`component-wrapper-main-tab ${isOverviewSelected ? "property-overview-tab" : ""}`}
                pinIcon={true}
                isParentTab
                alignItems="left"
                tabDetails={HomePageTabs}
                pinHandler={pinHandler}
                pinTabIndex={pinIndex}
                handlePinUnpin={handlePinUnpin}
                selectedTab={selectTab}
                unPinTab={pinIndex === 0 ? "dashboard_property_overview" : "my_dashboard"}
                PinIconProp={FilledPinned}
                showIconOnHover={true}
                UnPinIconProp={PinOff}
                onTabChangeFn={() =>
                  dispatch(
                    setCreatedDate({
                      createdDateFrom: null,
                      createdDateTo: null
                    })
                  )
                }
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Home;
